import { FieldConfig, FormStripeInput } from '@superhi/utils'

export const STRIPE_CARD: FieldConfig<typeof FormStripeInput> = {
  name: 'paymentMethodId',
  required: false,
}
